var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import AddIcon from "@mui/icons-material/Add";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import PersonRemoveOutlinedIcon from "@mui/icons-material/PersonRemoveOutlined";
import { Box, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Stack } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { getGuestStayStatusInfo } from "../../../utils/color.util";
import { GuestRow, useStayLine } from "./GuestRow";
import { getCompletedStays } from "../../profileIdentity/profileIdentity.util";
import { CardActionButton, CardTitle } from "../sidebar/SidebarCard";
// Keep the sticky header directly in the scrolling column; a wrapper would restrict its travel.
var OtherGuests = function (_a) {
    var profiles = _a.profiles, onSelect = _a.onSelect, onOpenFull = _a.onOpenFull, onRemove = _a.onRemove, onAdd = _a.onAdd;
    var t = useTranslation().t;
    var stayLine = useStayLine();
    var _b = useState(), menu = _b[0], setMenu = _b[1];
    var menuEntries = menu ? [
        onOpenFull && { label: t('Open full profile'), Icon: OpenInFullIcon, onClick: function () { return onOpenFull(menu.profile); } },
        onRemove && { label: t('Remove from reservation'), Icon: PersonRemoveOutlinedIcon, onClick: function () { return onRemove(menu.profile); }, danger: true },
    ].filter(Boolean) : [];
    var hasMenu = !!onOpenFull || !!onRemove;
    if (profiles.length === 0 && !onAdd) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(Box, __assign({ sx: {
                    position: 'sticky',
                    bottom: 0,
                    zIndex: 2,
                    mx: '-16px',
                    px: '16px',
                    py: '10px',
                    bgcolor: 'background.paper',
                    borderTop: '1px solid',
                    borderColor: 'divider'
                } }, { children: _jsx(CardTitle, { title: t('Other guests'), action: onAdd && _jsx(CardActionButton, __assign({ icon: _jsx(AddIcon, {}), onClick: onAdd }, { children: t('Add guest') })) }) })), profiles.length > 0 && (_jsx(Stack, __assign({ sx: { mt: '-16px' } }, { children: profiles.map(function (profile) {
                    var info = getGuestStayStatusInfo(profile);
                    return (_jsx(GuestRow, { profile: profile, completedStays: getCompletedStays(profile), line: stayLine(info === null || info === void 0 ? void 0 : info.status, info === null || info === void 0 ? void 0 : info.stay), onClick: function () { return onSelect(profile); }, action: hasMenu && (_jsx(IconButton, __assign({ "aria-label": t('More actions'), "aria-haspopup": 'menu', onClick: function (event) {
                                event.stopPropagation();
                                setMenu({ anchor: event.currentTarget, profile: profile });
                            }, onKeyDown: function (event) { return event.stopPropagation(); }, sx: { width: 36, height: 36, my: '-8px', borderRadius: '8px', color: 'text.secondary' } }, { children: _jsx(MoreVertIcon, { sx: { fontSize: 20 } }) }))) }, profile.id));
                }) }))), _jsx(Menu, __assign({ anchorEl: menu === null || menu === void 0 ? void 0 : menu.anchor, open: !!menu, onClose: function () { return setMenu(undefined); } }, { children: menuEntries.map(function (entry) { return (_jsxs(MenuItem, __assign({ onClick: function () {
                        setMenu(undefined);
                        entry.onClick();
                    }, sx: { color: entry.danger ? 'error.main' : undefined } }, { children: [_jsx(ListItemIcon, __assign({ sx: { color: entry.danger ? 'error.main' : undefined } }, { children: _jsx(entry.Icon, { fontSize: 'small' }) })), _jsx(ListItemText, { children: entry.label })] }), entry.label)); }) }))] }));
};
export default OtherGuests;
